module.exports = __webpack_public_path__ + "static/media/laptop-small-min-min.3fd133dd.png";